import { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WHATSAPP_NUMBERS = [
  { number: '+59894234593', label: 'Uruguay' },
  { number: '+16207946822', label: 'USA - AZ' },
  { number: '+12145520691', label: 'USA - TX' },
];

const WhatsAppButton = () => {
  const [open, setOpen] = useState(false);

  const openChat = (number) => {
    window.open(`https://wa.me/${number.replace('+', '')}?text=Hola, necesito ayuda con un servicio de Aircom Connect`, '_blank');
  };

  return (
    <div className="fixed bottom-20 right-4 z-50 lg:bottom-6" data-testid="whatsapp-widget">
      {open && (
        <div className="mb-3 bg-white rounded-2xl shadow-2xl border overflow-hidden w-72" style={{ animation: 'fadeIn 0.2s ease-out' }} data-testid="whatsapp-menu">
          <div className="bg-green-600 px-4 py-3 flex items-center justify-between">
            <span className="text-white font-semibold text-sm">Soporte WhatsApp</span>
            <button onClick={() => setOpen(false)} className="text-white/80 hover:text-white"><X className="w-4 h-4" /></button>
          </div>
          <div className="p-2">
            {WHATSAPP_NUMBERS.map((w) => (
              <button
                key={w.number}
                onClick={() => openChat(w.number)}
                className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-green-50 transition-colors text-left"
                data-testid={`wa-${w.number}`}
              >
                <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center shrink-0">
                  <svg viewBox="0 0 24 24" className="w-5 h-5 text-white fill-current">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                    <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.832-1.438A9.955 9.955 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a8 8 0 01-4.243-1.214l-.253-.156-2.889.858.858-2.889-.156-.253A8 8 0 1112 20z"/>
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium text-slate-900">{w.label}</p>
                  <p className="text-xs text-slate-500">{w.number}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen(!open)}
        className="w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 shadow-lg flex items-center justify-center transition-all hover:scale-110"
        data-testid="whatsapp-toggle"
      >
        {open ? <X className="w-6 h-6 text-white" /> : (
          <svg viewBox="0 0 24 24" className="w-7 h-7 text-white fill-current">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
            <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.832-1.438A9.955 9.955 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a8 8 0 01-4.243-1.214l-.253-.156-2.889.858.858-2.889-.156-.253A8 8 0 1112 20z"/>
          </svg>
        )}
      </button>
    </div>
  );
};

export default WhatsAppButton;
